import styled from 'styled-components';

export const SearchTabContainer = styled.div`
  .search-for {
    color: ${({ theme }) => theme.text1};
    font-weight: 500;
  }
  .no-data-found {
    font-size: 18px;
  }
  .post-back {
    z-index: 99;
    background-color: ${({ theme }) => theme.Bg1};
  }
  .segmented-tab .MuiBox-root {
    position: sticky;
    top: 90px;
    z-index: 99;
  }
`;

export const PeopleContainer = styled.div`
  color: ${({ theme }) => theme.text1};
`;

export const JobSearchContainer = styled.div`
  color: ${({ theme }) => theme.text1};
  .see-all-results {
    width: 100%;
    text-align: center;
    padding-top: 4px;
  }
  .job-list-item {
    height: auto;
    border-radius: 8px;
    padding: 8px 6px;
    margin: 8px 4px;
    box-shadow: ${({ theme }) => theme.boxShadow1};
  }
  .job-list-post-time {
    bottom: 0px;
  }
`;

export const BusinessHubContainer = styled.div`
  color: ${({ theme }) => theme.text1};
  margin-top: 8px;
`;
